import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterACircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLetterACircle"><Path d="M12.0586 9.4082L12.9492 12.5957H11.0566L11.9473 9.4082H12.0586Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.6875 7.54492L7.8457 16H10.1016L10.623 14.1426H13.3828L13.9043 16H16.1602L13.3184 7.54492H10.6875Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterACircle;
